import React, { memo } from 'react';
import CustomChart from '../components/CustomChart/CustomChart';

const options = {
  maintainAspectRatio: false,
  responsive: true,
};

const normalizedData = ({ labels, datasets }) => {
  const result = {
    labels,
    datasets: [
      {
        data: datasets?.[0]?.data ?? [],
        backgroundColor: ['#3db783', '#f9b903', '#e53c68'],
      },
    ],
  };

  return result;
};
const CustomerSentiment = (props) => {
  return (
    <CustomChart
      type={'pie'}
      {...props}
      normalizedData={normalizedData}
      getOption={() => options}
    />
  );
};

export default memo(CustomerSentiment);
